import React, { useEffect } from 'react';
import './Projects.css';

const MultiAgent = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="ma-detail-page">
            <div className="ma-detail-container">
                <div className="ma-detail-intro" data-aos="fade-up">
                    <span className="ma-detail-eyebrow">RESEARCH PROGRAMME</span>
                    <h1 className="ma-detail-title">Multi-Agent Systems &amp; Autonomous AI</h1>
                    <p className="ma-detail-subtitle">
                        Explore the rapidly emerging field of multi-agent systems. A comprehensive program designed for research scholars, graduate students, and professionals interested in the future of AI-driven scientific discovery.
                    </p>
                </div>

                <div className="ma-detail-media-wrap" data-aos="fade-up" data-aos-duration="1000">
                    <div className="ma-glow-img-box">
                        <img src="/images1.jpg.webp" alt="Multi-Agent System Blueprint" className="ma-blueprint-img" />
                    </div>
                </div>

                <div className="ma-detail-content-wrap" data-aos="fade-up" data-aos-duration="1000">
                    <div className="ma-content-glass-card">
                        <h2 className="ma-content-heading">
                            The Future of <span className="ma-text-gradient">AI-Driven</span> Scientific Discovery
                        </h2>
                        
                        <p className="ma-content-paragraph">
                            Dive into the foundations of AI agents, collaborative intelligence, and autonomous scientific workflows. Learn how intelligent agents can reason, coordinate tasks, analyze complex datasets, and assist in solving challenging scientific problems.
                        </p>
                        
                        <p className="ma-content-paragraph">
                            Gain hands-on experience designing and building multi-agent systems capable of automating research processes, performing literature analysis, coordinating computational experiments, and accelerating discovery in areas such as drug discovery and computational biology.
                        </p>
                        
                        <div className="ma-action-wrap">
                            <a 
                                href="https://forms.gle/yEq2APk4v5P9dHSz9" 
                                target="_blank" 
                                rel="noreferrer" 
                                className="ma-btn-register"
                            >
                                <span>Register Now</span>
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                    <polyline points="12 5 19 12 12 19"></polyline>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MultiAgent;
